import Character from './Character';
import { getTeamColor } from './helpers';

function SilverMedal({ ribbonColor = '#2E7D88' }) {
  return (
    <svg width="78" height="108" viewBox="0 0 80 110" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="secondSilverGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#F0F0F0" />
          <stop offset="50%" stopColor="#C0C0C0" />
          <stop offset="100%" stopColor="#909090" />
        </linearGradient>
      </defs>
      <path
        d="M 20 5 L 40 50 L 60 5 L 52 5 L 40 32 L 28 5 Z"
        fill={ribbonColor}
        stroke="#1a1a1a"
        strokeWidth="1"
        opacity="0.95"
      />
      <circle cx="40" cy="72" r="28" fill="url(#secondSilverGrad)" stroke="#707070" strokeWidth="2" />
      <circle cx="40" cy="72" r="22" fill="none" stroke="#909090" strokeWidth="1.5" />
      <text
        x="40"
        y="82"
        textAnchor="middle"
        fontSize="28"
        fontWeight="900"
        fill="#606060"
        fontFamily="Inter, sans-serif"
        fontStyle="italic"
      >
        2
      </text>
      <ellipse cx="30" cy="62" rx="6" ry="10" fill="#FFFFFF" opacity="0.5" />
    </svg>
  );
}

// Shown to the instructor (rotating with Champions) and to every student
// on the runner-up team after Process Final Results is clicked. Renders
// two characters paired close together so the celebration reads as a
// bonded team rather than two separate users. Both wear the 'composed'
// expression — between smiling and sad — since they reached the Finals
// but didn't take the championship.
export default function SecondPlace({ team, stats = null }) {
  const teamColor = team ? getTeamColor(team.name) : '#2E7D88';

  return (
    <>
      <div className="celebration-header">
        <div className="celebration-kicker" style={{ color: teamColor }}>A Great Run</div>
        <div style={{ display: 'inline-block', marginBottom: '16px' }}>
          <SilverMedal ribbonColor={teamColor} />
        </div>
        <h1 className="celebration-title">So close.</h1>
        <div
          className="celebration-team-pill"
          style={{ background: '#FFFFFF', color: '#2F4166', border: `2px solid ${teamColor}` }}
        >
          {team?.name || 'Runner-Up'}
        </div>
        <div className="celebration-subtitle">
          You fought all the way to the Finals. That's a season worth being proud of.
        </div>
      </div>

      <div className="celebration-characters-grid grid-pairs">
        <div className="celebration-character-cell" style={{ animationDelay: '0.2s' }}>
          <div className="celebration-character-pair">
            <Character color={teamColor} dance="idle" pose="composed" size="large" />
            <Character color={teamColor} dance="idle" pose="composed" size="large" />
          </div>
        </div>
      </div>

      {stats && (
        <div className="celebration-stats">
          {stats.map(s => (
            <div key={s.label} className="celebration-stat-cell">
              <div className="celebration-stat-value">{s.value}</div>
              <div className="celebration-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
